<template>
<div>
  <div justify="center" >
     <v-card class=" mt-4 mx-auto" max-width="1000" min-width="300">
        
  <v-expand-transition>
    <div class="ma-3">
       <Violations
          :schoolId="schoolId"
          id=""
          typ=""
          v-model="Hide"
        />
 
    </div> 
  </v-expand-transition>
  </v-card>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Violations from '../components/violationreport/Violations.vue';

export default {
   props: {
    schoolId: String
  },
    data: () => ({
      Hide: true,
  }),

  watch: {
    school: function (val) {
     this.Hide=true;
         },
  },

  methods: {


  
  },
    computed: {
   
    
    ...mapGetters('schools', ['school']),

  },
  components: {
    Violations
    // classrooms

  }
}
</script>